export const quickLinkTypes = {
  uploadedFile: 0,
  url: 1
} as const;

export type QuickLinkType = (typeof quickLinkTypes)[keyof typeof quickLinkTypes];

export type QuickLinkModel = {
  Category: string;
  CreatedOn: string;
  Id: number;
  DisplayName: string;
  FileName?: string | null;
  LegacyDocumentLinkId?: number | null;
  QuickLinkType: QuickLinkType;
  ResolvedUrl?: string | null;
  ShowInNav: boolean;
  UpdatedOn: string;
  Url?: string | null;
};

export type QuickLinkCategoryModel = {
  Category: string;
  Links: QuickLinkModel[];
};

export type SaveQuickLinkInput = {
  category?: string;
  displayName: string;
  file?: File;
  fileName?: string;
  quickLinkType: QuickLinkType;
  showInNav: boolean;
  url?: string;
};
